module.exports = __webpack_public_path__ + "static/media/noun_User_103879.2563888d.svg";